
    import './styles.scoped.css';
    export default {
  "layout": "awsui_layout_5gtk3_set91_105",
  "is-visual-refresh": "awsui_is-visual-refresh_5gtk3_set91_105",
  "background": "awsui_background_5gtk3_set91_108",
  "header": "awsui_header_5gtk3_set91_111",
  "is-overlap-disabled": "awsui_is-overlap-disabled_5gtk3_set91_127",
  "content": "awsui_content_5gtk3_set91_135",
  "has-header": "awsui_has-header_5gtk3_set91_139"
};
  